module.exports = __webpack_public_path__ + "static/media/document-thumbnail-CBRimg4@2x.3d4a644f.png";